import React from "react";
// @material-ui/core components
import {withStyles} from "@material-ui/core/styles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";


import ProjectCard from "../Components/ProjectCard";
import {Projects} from "../../../database/dictionary";
import portfolioStyle from "../../../assets/jss/material-kit-react/views/landingPageSections/portfolioStyle";
import Button from "../../../components/CustomButtons/Button";
import {Link} from "react-router-dom";

class PortfolioSection extends React.Component {
    render() {
        const {classes} = this.props;
        return (
            <div className={classes.section}>
                <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={8}>
                        <h2 className={classes.title}>Highlighted projects</h2>
                        <h5 className={classes.description}>
                            Here are the most notable projects I was part of.
                        </h5>
                    </GridItem>
                </GridContainer>
                <div>
                    <GridContainer justify="center" alignItems="stretch" spacing={24} className={classes.grid}>
                        {
                            Projects.filter(item => item.highlighted).map(item =>
                                <GridItem xs={12} sm={12} md={6} key={item.name}>
                                    <ProjectCard item={item}/>
                                </GridItem>
                            )
                        }
                    </GridContainer>
                </div>
                <GridContainer justify="center">
                    <Link to={{pathname: '/projects'}}>
                        <Button color="action"><h4>See more projects</h4></Button>
                    </Link>
                </GridContainer>
            </div>
        );
    }
}

export default withStyles(portfolioStyle)(PortfolioSection);



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/PortfolioSection.jsx